export default {
  None: 0,
  MRMR: 1,
  Geo: 2,
  CashFlow: 4,
  Drilling: 8
}